/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const enum APIType {
    Internal,
    External,
}

export interface FlexibleSearchParams {
    months: string[];
    nights: number;
    weekendsOnly: boolean;
}
